module.exports = __webpack_public_path__ + "img/icon22.c625019d.png";